import ViewReporteCompra from "../../components/View-reporte-compra/ViewReporteCompra";

export default function ViewReporteCompraPage() {
  //useCheckPermissions()
return <ViewReporteCompra titlePage="Reporte de Compras"/>
}